var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFullScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 21 21",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M15.412 5.646V7.99a.39.39 0 0 1-.781 0V6.589l-2.458 2.458a.39.39 0 0 1-.553 0 .39.39 0 0 1 0-.552l2.459-2.458h-1.401a.39.39 0 0 1 0-.782h2.343a.39.39 0 0 1 .391.391M9.048 8.495 6.589 6.037H7.99a.39.39 0 0 0 0-.782H5.646a.39.39 0 0 0-.39.391V7.99a.39.39 0 0 0 .781 0V6.589l2.458 2.458a.39.39 0 0 0 .553 0 .39.39 0 0 0 0-.552m5.973 3.792a.39.39 0 0 0-.39.39v1.401l-2.458-2.458a.39.39 0 1 0-.553.552l2.459 2.458h-1.401a.39.39 0 0 0 0 .782h2.343a.39.39 0 0 0 .391-.391v-2.344a.39.39 0 0 0-.39-.39Zm-5.973-.667a.39.39 0 0 0-.553 0l-2.458 2.458v-1.4a.39.39 0 0 0-.781 0v2.343c0 .216.175.39.39.39H7.99a.39.39 0 0 0 0-.78h-1.4l2.458-2.459a.39.39 0 0 0 0-.552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFullScreen);
export default __webpack_public_path__ + "static/media/IcoFullScreen.1b263cc04315356b4cf4bead4af98a33.svg";
export { ForwardRef as ReactComponent };